// Lightweight telemetry queue; can be replaced with real backend later
export interface TelemetryEvent { t: number; type: string; [k: string]: any; }

class Telemetry {
  private buffer: TelemetryEvent[] = [];
  private flushed = 0;
  push(ev: Omit<TelemetryEvent,'t'>){
    const e = { ...ev, t: Date.now() } as TelemetryEvent;
    this.buffer.push(e);
    if (this.buffer.length >= 20) this.flush();
  }
  flush(){
    if(!this.buffer.length) return;
    // Future: send to /telemetry endpoint
    // eslint-disable-next-line no-console
    console.debug('[telemetry] flush', this.buffer.length);
    this.flushed += this.buffer.length;
    this.buffer = [];
  }
  getStats(){ return { pending: this.buffer.length, flushed: this.flushed }; }
}
export const telemetry = new Telemetry();
